import UrlPrefixes from "../../constants/urlPrefixes";

export default v2Link => {
  const path = v2Link.absolutePath.replace(UrlPrefixes.FILE_PREFIX, UrlPrefixes.LOCAL_PREFIX);
  return {
    id: v2Link.guid,
    label: v2Link.title,
    path: path
  };
};
